import { TTimeline } from '@/types/Timeline.types.ts';
import { api, TCustomAxiosResponse } from '..';
import { apiPaths } from '@/services/api/paths';

export const getOwnTimeline = async (): Promise<TTimeline[]> => {
  const { data } = await api.get<TCustomAxiosResponse<TTimeline[]>>(apiPaths.timeline.self);
  const notes = data.data;

  return notes;
};
